<template>
    <span>
        <el-dropdown class="hidden md:block">
            <button class="text-center text-gray-600 hover:text-blue-500 hidden md:block" :class="{'text-brand': notificationCount}">
                    <i class="uil uil-bell text-2xl"></i>
                    <span v-if="notificationCount && hasMessengerManagement" class="notification-bubble">{{notificationCountLabel}}</span>
                    <!-- <span v-if="notificationCount" class="animate-ping absolute -mt-8 ml-5 rounded-full bg-pink-400 opacity-75 w-4 h-4 block text-xs text-white"></span>
                    <span v-if="notificationCount" class="absolute -mt-8 ml-5 rounded-full px-1 bg-pink-500 w-auto h-4 block text-xs text-white">{{notificationCount}}</span> -->
            </button>  
            <el-dropdown-menu slot="dropdown" class="mt-0 w-120 hidden md:block pt-0">
                <div class="flex justify-center mt-0 space-x-14 px-2 md:px-0 w-full">
                    <el-radio-group v-model="toggleNotifications" size="small" class="w-full inline-block">
                        <el-radio-button class="focus:outline-none w-1/2" label="Notifications" style="display: inline-grid !important">{{notificationRegularCount > 0 && hasMessengerManagement ? 'Notifications (' + notificationRegularCountLabel +')' : 'Notifications'}}</el-radio-button>
                        <el-radio-button class="focus:outline-none w-1/2" label="Hera Version History" style="display: inline-grid !important">{{notificationNewVersionCount > 0 ? 'Hera Version History (' + notificationNewVersionCountLabel + ')' : 'Hera Version History'}}</el-radio-button>
                    </el-radio-group>
                </div>
                <template v-if="toggleNotifications === 'Notifications' ? 'Notifications' : 'Hera Version History'">
                    <div v-if="notificationCount" class="divide-y overflow-y-auto" style="max-height: 400px">
                        <div data-cy="notification-row" class="flex items-center justify-between px-3 py-2" 
                            v-for="notification in (toggleNotifications === 'Notifications' ? displayRegularNotifications : displayNewVersionNotifications)" 
                            :key="notification.id"
                        >
                            <div class="flex-grow text-left">
                                <button 
                                    data-cy="n-perform-action-btn" 
                                    @click="canClickExportNotification(notification) ? performAction(notification) : null" 
                                    :class="['text-left block w-full', canClickExportNotification(notification) ? 'hover:text-brand' : 'cursor-default']"
                                >
                                    <p data-cy="n-title" class="text-sm">{{getNotificationTitle(notification)}}</p>
                                    
                                    <div data-cy="n-description" class="text-xs text-gray-600 preline mt-1">
                                        <span v-if="!isExportNotification(notification)" v-html="getNotificationDescription(notification)"></span>
                                        
                                        <div v-else v-html="getProcessedZipDescription(notification)"></div>
                                    </div>
                                </button>

                                <div data-cy="n-release-notes" v-if="notification.releaseNotes" class="text-xs text-gray-600 whitespace-pre-line">
                                    {{notification.releaseNotes}}
                                </div>
                            </div>

                            <button data-cy="n-dismiss-btn" @click="dismiss(notification)" class="px-2">
                                <i class="uil uil-multiply ml-2 text-gray-600 hover:text-red-600"></i>
                            </button>
                        </div>
                    </div>
                    <div v-else class="p-3 text-center w-full">
                        <i class="text-6xl mb-4 text-gray-600 uil uil-bell"/>
                        <p class="text-sm text-gray-700">No Unread Notifications</p>
                    </div>
                    <p class=" px-3 pt-3 pb-1 text-center border-t flex justify-around">
                        <button data-cy="n-dismiss-all-btn" v-if="notificationCount" @click="dismissAll()" class="text-xs  text-gray-600 hover:text-red-600" href="#">{{toggleNotifications === 'Notifications' ? 'Dismiss All Notifications' : 'Dismiss All Version History'}}</button>
                        <a data-cy="n-view-all-btn" class="text-xs link"  @click="$router.push({name: 'NotificationIndex', params: {optionID: filteredOptionID}})">{{toggleNotifications === 'Notifications' ? 'View All Notifications' : 'View All Version History'}}</a>
                    </p>
                </template>                
            </el-dropdown-menu>
            
        </el-dropdown>
        <span v-if="notificationCount && hasMessengerManagement" class="rounded-full bg-pink-500 h-4 py-0.5  px-1 text-xs text-white mr-2 md:hidden">{{notificationCountLabel}}</span>
    </span>
</template>

<script>
import { storeDataInAthena } from '@/utilities/athena'
import { getFullName } from '@/utilities/associate'
import {mapState, mapGetters} from 'vuex'
import EventBus from '@/eventBus'
import { HIDDEN, COUNSELING_ACKNOWLEDGMENT, EXPORT_READY_FOR_DOWNLOAD, HERA_MESSENGER_NEW_MESSAGE, SCHEDULING_SHIFTS_REVIEW, SCHEDULING_SHIFTS_IMPORT_COMPLETE, DOCUMENT_SIGNATURE_ACKNOWLEDGMENT, ASSOCIATE_REQUEST_CREATED, PAYROLL_PROVIDER_MATCHES_FOUND } from '@/utilities/constants/notificationTypes'
import { sortByDateProp } from '@/utilities/sortHelpers'
import { updateUserNotification, updateNotification, createMessageReadStatus, updateMessageReadStatus } from '@/store/mutations'
import { messageReadStatusByUserAndStaff, messageReadStatusByUserAndDevice } from '@/views/Messenger/queries'
import { notificationsByOwnerAndIsReadS } from '@/store/queries'
import { markNotificationsReadInBatches, findUnreadMessengerNotificationsForThread, loadUnreadUserNotificationsForDismissal } from '@/utilities/bellNotificationDismissal'
import { refreshNotificationCounts } from '@/store/subscriptionModule/nested/notificationSubscriptions'
import { apiPostCompressed } from '@/utilities/apiCallCompressed'
import { processExportNotificationDescription, shiftImportCompleteDestination, payrollProviderMatchesPath } from '@/utilities/notificationHelpers'

let listenersRegistered = false;
let shownNotifications = new Set();

export default {

    data(){
        return{
            tabs: [
                {name: 'notifications', table: [], title: 'Notifications'},
                {name: 'heraVersionHistory', table: [], title: 'Hera Version History'}
            ],
            toggleNotifications: 'Notifications',
        }
    },

    mounted(){
        if (listenersRegistered) return;
        listenersRegistered = true;
        
        EventBus.$off('missing-phone-number', this.onMissingPhoneNumber);
        EventBus.$on('missing-phone-number', this.onMissingPhoneNumber);

        EventBus.$off('sent-messages-successfully', this.onSentMessagesSuccessfully);
        EventBus.$on('sent-messages-successfully', this.onSentMessagesSuccessfully);

        EventBus.$off('remove-all-associates', this.onRemoveAllAssociates);
        EventBus.$on('remove-all-associates', this.onRemoveAllAssociates);

        EventBus.$off('no-associates-to-remove', this.onNoAssociatesToRemove);
        EventBus.$on('no-associates-to-remove', this.onNoAssociatesToRemove);

        EventBus.$off('customlists-created-successfully', this.onCustomListsCreatedSuccessfully);
        EventBus.$on('customlists-created-successfully', this.onCustomListsCreatedSuccessfully);

        EventBus.$off('customlists-updates-successfully', this.onCustomListsUpdatesSuccessfully);
        EventBus.$on('customlists-updates-successfully', this.onCustomListsUpdatesSuccessfully);

        EventBus.$off('customlists-created-error', this.onCustomListsCreatedError);
        EventBus.$on('customlists-created-error', this.onCustomListsCreatedError);

        EventBus.$off('customlists-updates-error', this.onCustomListsUpdatesError);
        EventBus.$on('customlists-updates-error', this.onCustomListsUpdatesError);

        EventBus.$off('override-resource-usage', this.onOverrideResourceUsage);
        EventBus.$on('override-resource-usage', this.onOverrideResourceUsage);

        EventBus.$off('note-updates-error', this.onNoteUpdatesError);
        EventBus.$on('note-updates-error', this.onNoteUpdatesError);

        EventBus.$off('counseling-table-updates', this.onCounselingTableUpdates);
        EventBus.$on('counseling-table-updates', this.onCounselingTableUpdates);

        EventBus.$off('counseling-table-updates-error', this.onCounselingTableUpdatesError);
        EventBus.$on('counseling-table-updates-error', this.onCounselingTableUpdatesError);

        EventBus.$off('tenant-table-updates', this.onTenantTableUpdates);
        EventBus.$on('tenant-table-updates', this.onTenantTableUpdates);

        EventBus.$off('tenant-table-updates-error', this.onTenantTableUpdatesError);
        EventBus.$on('tenant-table-updates-error', this.onTenantTableUpdatesError);

        EventBus.$on('zip-export-notification', this.onZipExportNotification);
    },

    beforeDestroy(){
        EventBus.$off('missing-phone-number', this.onMissingPhoneNumber);
        EventBus.$off('sent-messages-successfully', this.onSentMessagesSuccessfully);
        EventBus.$off('remove-all-associates', this.onRemoveAllAssociates);
        EventBus.$off('no-associates-to-remove', this.onNoAssociatesToRemove);
        EventBus.$off('customlists-created-successfully', this.onCustomListsCreatedSuccessfully);
        EventBus.$off('customlists-updates-successfully', this.onCustomListsUpdatesSuccessfully);
        EventBus.$off('customlists-created-error', this.onCustomListsCreatedError);
        EventBus.$off('customlists-updates-error', this.onCustomListsUpdatesError);
        EventBus.$off('override-resource-usage', this.onOverrideResourceUsage);
        EventBus.$off('note-updates-error', this.onNoteUpdatesError);
        EventBus.$off('counseling-table-updates', this.onCounselingTableUpdates);
        EventBus.$off('counseling-table-updates-error', this.onCounselingTableUpdatesError);
        EventBus.$off('tenant-table-updates', this.onTenantTableUpdates);
        EventBus.$off('tenant-table-updates-error', this.onTenantTableUpdatesError);
        EventBus.$off('zip-export-notification', this.onZipExportNotification);
    },

    watch: {
        async notificationCount(newVal, oldVal){
            
            await storeDataInAthena('notificationCount', newVal)

            if(newVal > 0 && this.regularNotifications){
                // trigger reload of performance screen
                 EventBus.$emit('load-performance')
            }
        }
    },

    computed:{
        ...mapState("subscriptionStore",[
            'regularNotifications',
            'newVersionNotifications',
            'regularNotificationCount',
            'newVersionNotificationCount',
            'regularNotificationCountSaturated',
            'newVersionNotificationCountSaturated'
        ]),
        ...mapGetters(['hasMessengerManagement']),
        filteredOptionID(){
            if(this.toggleNotifications === "Hera Version History"){
                return 'heraVersion'
            }
            return 'general'
        },
        notificationCount(){
            return this.regularNotificationCount + this.newVersionNotificationCount
        },

        notificationRegularCount() {
            return this.regularNotificationCount
        },

        notificationNewVersionCount() {
            return this.newVersionNotificationCount
        },

        // A count that hit the server's read cap is a lower bound: show "1500+"
        notificationCountLabel() {
            const saturated = this.regularNotificationCountSaturated || this.newVersionNotificationCountSaturated
            return saturated ? `${this.notificationCount}+` : this.notificationCount
        },

        notificationRegularCountLabel() {
            return this.regularNotificationCountSaturated ? `${this.notificationRegularCount}+` : this.notificationRegularCount
        },

        notificationNewVersionCountLabel() {
            return this.newVersionNotificationCountSaturated ? `${this.notificationNewVersionCount}+` : this.notificationNewVersionCount
        },

        displayRegularNotifications() {
            this.regularNotifications.lastRenderKey
            return this.regularNotifications
        },

        displayNewVersionNotifications() {
            this.newVersionNotifications.lastRenderKey
            return this.newVersionNotifications
        }
    },
    methods:{
        getNotificationTitle(notification) {
            if (notification.notificationType === COUNSELING_ACKNOWLEDGMENT) {
                try {
                const payload = JSON.parse(notification.payload)
                return payload.inApp?.title || notification.title
                } catch (e) {
                console.error('Error parsing notification payload:', e)
                return notification.title
                }
            }
            return notification.title
        },

        getNotificationDescription(notification) {
            if (notification.notificationType === COUNSELING_ACKNOWLEDGMENT) {
                try {
                const payload = JSON.parse(notification.payload)
                return payload.inApp?.message || notification.description
                } catch (e) {
                console.error('Error parsing notification payload:', e)
                return notification.description
                }
            }
            return notification.description
        },
        async performAction(notification){
            try {
                const payload = JSON.parse(notification.payload)
                if (notification.notificationType === COUNSELING_ACKNOWLEDGMENT && payload.inApp?.counselingId) {
                    this.dismiss(notification)
                    // Route to counseling detail page
                    this.$router.push({ name: 'CounselingDetail', params: { counselingId: payload.inApp.counselingId } });
                }
                else if (notification.notificationType === SCHEDULING_SHIFTS_REVIEW && payload.inApp?.link) {
                    this.dismiss(notification)
                    // Only navigate if link is a relative internal path
                    const link = payload.inApp.link
                    if (link.startsWith('/')) {
                        this.$router.push(link)
                    }
                }
                else if (notification.notificationType === SCHEDULING_SHIFTS_IMPORT_COMPLETE) {
                    // HA-2978 Deliverable B (AC 2): await dismiss so the notification is marked
                    // read before the full-page navigation tears down the in-flight update
                    // request (same reason the associate-request branch awaits its dismiss).
                    await this.dismiss(notification)
                    // Success vs failure is decided by the promoter's terminal job status on the
                    // payload, not by link presence — see shiftImportCompleteDestination.
                    const importDestination = shiftImportCompleteDestination(payload.inApp)
                    if (importDestination.kind === 'athena') {
                        // A SUCCESSFUL import lands in the Athena scheduler, so the user goes to
                        // Planning via goToAthena (${origin}/ath/scheduler/planning) — NOT
                        // $router.push, which does not own /ath/*. The path is already relative
                        // to /ath; goToAthena is the single place that prefix is added.
                        window.location.href = this.goToAthena(importDestination.path)
                    } else if (importDestination.kind === 'internal') {
                        this.$router.push(importDestination.path)
                    }
                }
                else if (notification.notificationType === DOCUMENT_SIGNATURE_ACKNOWLEDGMENT && payload.inApp?.signingRequestId) {
                    // Await dismiss so the notification is marked read before the full-page
                    // navigation tears down the in-flight update request.
                    await this.dismiss(notification)
                    // Signature requests live in the Athena app — goToAthena builds the
                    // absolute cross-app URL (${origin}/ath/documents/:id).
                    window.location.href = this.goToAthena(`/documents/${payload.inApp.signingRequestId}`)
                }
                else if (notification.notificationType === ASSOCIATE_REQUEST_CREATED) {
                    // Await dismiss so the notification is marked read before the full-page
                    // navigation tears down the in-flight update request.
                    await this.dismiss(notification)
                    // Associate requests are reviewed in the Athena scheduler — goToAthena builds
                    // the absolute cross-app URL (${origin}/ath/scheduler/associate-requests).
                    // The destination is the same for every request, so nothing is read from the payload.
                    window.location.href = this.goToAthena('/scheduler/associate-requests')
                }
                else if (notification.notificationType === PAYROLL_PROVIDER_MATCHES_FOUND) {
                    // HERA-9207: the link lives in payload.inApp.link. A missing/unsafe link or a
                    // flat payload (no inApp) leaves the entry inert: no dismiss, no navigation.
                    const payrollPath = payrollProviderMatchesPath(payload.inApp)
                    if (payrollPath) {
                        // Await dismiss so the notification is marked read before the full-page
                        // navigation tears down the in-flight update request.
                        await this.dismiss(notification)
                        // The helper strips the producer's leading '/ath' because goToAthena adds it.
                        window.location.href = this.goToAthena(payrollPath)
                    }
                }
                else if(notification.clickAction == "navigate"){
                    if(payload?.name === 'AmazonImport') payload.name = 'DailyAmazonImport'
                    this.dismiss(notification)
                    if (this.$route.name !== payload.name) this.$router.push(payload)
                }
                else if(notification.clickAction == "dismiss" || notification.clickAction == 'LOGOUT' || notification.clickAction == 'RELOAD'){
                    this.dismiss(notification)
                }
                else if (notification.notificationType === EXPORT_READY_FOR_DOWNLOAD && payload.s3Key) {
                    // On-demand presigned URL regeneration: the original presigned URL in
                    // payload.redirectLink expires with the Lambda's STS credentials (~12h).
                    // Call rdsApi /downloadS3File at click time to mint a fresh URL.
                    const s3Keys = Array.isArray(payload.s3Keys) && payload.s3Keys.length ? payload.s3Keys : [payload.s3Key]
                    for (const s3key of s3Keys) {
                        try {
                            const response = await apiPostCompressed('rds', '/downloadS3File', { body: { s3key } })
                            const signedUrl = response?.data?.signedUrl
                            if (!signedUrl) {
                                this.$message.error('This export file has expired and is no longer available.')
                                continue
                            }
                            // Use programmatic <a> click instead of window.open() to avoid
                            // popup blockers when downloading multiple files sequentially.
                            const link = document.createElement('a')
                            link.href = signedUrl
                            link.target = '_blank'
                            link.rel = 'noopener noreferrer'
                            document.body.appendChild(link)
                            link.click()
                            document.body.removeChild(link)
                        } catch (e) {
                            this.$message.error('This export file has expired and is no longer available.')
                        }
                    }
                }
                else if (notification.clickAction == "redirect") {
                    //const payload = JSON.parse(notification.payload);
                    window.open(payload.redirectLink, '_blank');
                }
                else if(payload.name === 'MessengerV2'){
                    // MessengerV2 notifications come from Athena's Sendbird-based messenger.
                    // Always redirect to Athena messenger for these.
                    // Await dismiss so the notification is marked read before the full-page
                    // navigation tears down the in-flight update request.
                    await this.dismiss(notification)
                    const channelUrl = payload.channel_url
                    let messengerPath = '/messenger'
                    if (channelUrl) {
                        messengerPath = `/messenger?channel_url=${channelUrl}`
                    }
                    window.location.href = this.goToAthena(messengerPath)
                }
                else if(payload.name && payload.params){
                    // HERA_MESSENGER_NEW_MESSAGE notifications come from the old SMS-based messenger
                    // (handleTextResponse Lambda). These always go to the old Messenger route,
                    // even if the tenant has Athena MessengerV2 enabled — the two are independent
                    // systems. Old messenger handles SMS via Telnyx, Athena messenger uses Sendbird.
                    // The messages won't exist in Athena messenger.
                    const shouldNavigate = this.$route.name !== payload.name || this.$route.params.staffId !== payload.params.staffId
                    // Dismiss ALL notifications for this staff's chat, not just the clicked one
                    await this.dismissAllNotificationsForStaff(payload.params?.staffId)
                    if (shouldNavigate) {
                        this.$router.push({name: payload.name, params: payload.params}).catch(() => {})
                    }
                }
                else if(payload.redirectLink){
                    window.open(payload.redirectLink, '_blank');
                }
                else{
                    //unknown action
                }
            } catch (e) {
                console.error('Error performing notification action:', e)
            }
        },
        async dismissAll(){
            let displayNotificationOption = this.toggleNotifications === 'Notifications' ? this.displayRegularNotifications : this.displayNewVersionNotifications
            // return console.log('version data', d)
            var notifications = displayNotificationOption
            const totalCount = this.toggleNotifications === 'Notifications' ? this.notificationRegularCountLabel : this.notificationNewVersionCountLabel
            try{
                await this.$confirm(`Are you sure you want to dismiss these ${totalCount} notifications?`, 'Warning',
                    {
                        confirmButtonText: 'Dismiss',
                        type: 'warning'
                    }
                )
                // Gather the full set of notifications to dismiss, de-duplicated by id,
                // then flip them in parallel batches (faster than the old one-at-a-time loop).
                const dismissedIds = new Set()
                const toDismiss = []
                const enqueue = (notification) => {
                    if (notification && !dismissedIds.has(notification.id)) {
                        dismissedIds.add(notification.id)
                        toDismiss.push(notification)
                    }
                }
                // Visible notifications
                for (const notification of notifications) {
                    enqueue(notification)
                }
                // Also include any remaining unread UserNotifications not in the display array
                if (this.toggleNotifications === 'Notifications') {
                    try {
                        const userId = this.$store.state.userInfo.id
                        const allUnread = await loadUnreadUserNotificationsForDismissal(userId)
                        for (const notif of allUnread) {
                            enqueue(notif)
                        }
                    } catch (e) {
                        console.error('Failed to load remaining notifications:', e)
                    }
                }
                // Also include any remaining unread legacy Notifications not in the display array.
                // Notifications tab clears non-version records; Hera Version History tab clears "NEW VERSION" records.
                try {
                    const owner = this.$store.state.userInfo.cognitoSub
                    const allUnreadLegacy = await this.gLoadListAll(notificationsByOwnerAndIsReadS, {
                        owner,
                        isReadS: { eq: 'false' }
                    }, 'notificationsByOwnerAndIsReadS')
                    for (const notif of allUnreadLegacy) {
                        const isVersion = notif.title === 'NEW VERSION'
                        const belongsToActiveTab = this.toggleNotifications === 'Hera Version History' ? isVersion : !isVersion
                        if (belongsToActiveTab) {
                            enqueue(notif)
                        }
                    }
                } catch (e) {
                    console.error('Failed to load remaining notifications:', e)
                }
                await this.dismissNotificationsInBatches(toDismiss)
                refreshNotificationCounts()
            }catch(e){
                if(e != 'cancel'){
                    this.displayUserError("Could not dismiss all notifications")
                }
            }
        },
        async dismissNotificationsInBatches(toDismiss){
            if (!toDismiss.length) return
            // Flip the isRead flag in parallel batches. Messenger sync is deferred and
            // de-duplicated per staff/device below to avoid duplicate MessageReadStatus writes.
            await markNotificationsReadInBatches(toDismiss)
            // Sync messenger read status once per unique staff/device (not per notification),
            // which both removes the prior race condition and avoids redundant writes.
            const syncedKeys = new Set()
            for (const notification of toDismiss) {
                if (notification.notificationType !== HERA_MESSENGER_NEW_MESSAGE) continue
                try {
                    const payload = JSON.parse(notification.payload)
                    const staffId = payload.params?.staffId
                    if (!staffId) continue
                    const key = `${payload.params?.type === 'device' ? 'device' : 'staff'}:${staffId}`
                    if (syncedKeys.has(key)) continue
                    syncedKeys.add(key)
                    await this.syncMessengerReadStatus(notification)
                } catch (e) { /* skip malformed payload */ }
            }
        },
        async dismiss(notification){
            if(notification.userId){
                //user notification
                let input = {
                    isRead: "true",
                    id: notification.id
                }
                await this.api(updateUserNotification, {input})
                // Sync to Messenger read status
                if (notification.notificationType === HERA_MESSENGER_NEW_MESSAGE) {
                    await this.syncMessengerReadStatus(notification)
                }
            }else{
                let input = {
                    isReadS: "true",
                    id: notification.id
                }
                await this.api(updateNotification, {input})
            }
        },
        async syncMessengerReadStatus(notification) {
            try {
                const payload = JSON.parse(notification.payload)
                const staffId = payload.params?.staffId
                if (!staffId) return
                const group = this.$store.state.userInfo.tenant.group
                const userID = this.$store.state.userInfo.id
                const isDevice = payload.params?.type === 'device'
                const readUpToDateTime = new Date().toISOString()

                let record = null
                if (isDevice) {
                    const resp = await this.gLoadListAll(messageReadStatusByUserAndDevice, {
                        group,
                        deviceIDUserID: { eq: { deviceID: staffId, userID } }
                    }, 'messageReadStatusByUserAndDevice')
                    record = resp[0]
                } else {
                    const resp = await this.gLoadListAll(messageReadStatusByUserAndStaff, {
                        group,
                        staffIDUserID: { eq: { staffID: staffId, userID } }
                    }, 'messageReadStatusByUserAndStaff')
                    record = resp[0]
                }

                if (record) {
                    await this.api(updateMessageReadStatus, { input: { id: record.id, readUpToDateTime } })
                } else {
                    await this.api(createMessageReadStatus, {
                        input: {
                            group,
                            userID,
                            staffID: isDevice ? 'NONE' : staffId,
                            deviceID: isDevice ? staffId : 'NONE',
                            readUpToDateTime
                        }
                    })
                }
            } catch (e) {
                console.error('Failed to sync messenger read status:', e)
            }
        },
        async dismissAllNotificationsForStaff(staffId) {
            try {
                if (!staffId) return
                const userId = this.$store.state.userInfo.id
                const matches = await findUnreadMessengerNotificationsForThread(userId, staffId)
                // Batched writes, then one messenger read-status sync for the thread
                await this.dismissNotificationsInBatches(matches)
            } catch (e) {
                console.error('Failed to dismiss all notifications for staff:', e)
            }
        },
        async onMissingPhoneNumber(payload) {
            if (shownNotifications.has(payload.id)) return;
            shownNotifications.add(payload.id);
            
            await this.displayUserNotification({
              title: payload.title,
              type: "warning",
              duration: 0,
              message: payload.description
            })
        },
        async onSentMessagesSuccessfully(payload) {
            await this.displayUserNotification({
                title: payload.title,
                type: "success",
                duration: 0,
                message: payload.description
            })
            
            const notificationPayload = JSON.parse(payload.payload)
            const staffsWithoutPhone = notificationPayload.staffsWithoutPhone || []
            if(staffsWithoutPhone.length) {
                for (const staff of staffsWithoutPhone) {
                    const key = `${payload.id}-${staff.id}`;
                    if (shownNotifications.has(key)) continue;
                    shownNotifications.add(key);
                    const destinationName = getFullName(staff)
                    const title = "Associate does not have a phone number"
                    const description = `${destinationName} does not have a phone number in their Associate profile. ${destinationName} did not receive this message. Please add their phone number to Hera then send this message again.`

                    await this.displayUserNotification({
                        title: title,
                        type: "warning",
                        duration: 0,
                        message: description
                    })
                }
            }
        },
        async onRemoveAllAssociates(payload) {
             if (shownNotifications.has(payload.id)) return;
                 shownNotifications.add(payload.id); 
            await this.displayUserNotification({
              title: payload.title,
              type: "success",
              duration: 0,
              message: payload.description
            })
        },
        async onNoAssociatesToRemove(payload) {
            if (shownNotifications.has(payload.id)) return;
                shownNotifications.add(payload.id); 
            await this.displayUserNotification({
              title: payload.title,
              type: "info",
              duration: 0,
              message: payload.description
            })
        },
        async onCustomListsCreatedSuccessfully(payload) {
            if (shownNotifications.has(payload.id)) return;
                shownNotifications.add(payload.id); 
            await this.displayUserNotification({
              title: payload.title,
              type: "success",
              duration: 0,
              message: payload.description
            })
        },
        async onCustomListsUpdatesSuccessfully(payload) {
            this.loadCustomList()

            await this.displayUserNotification({
              title: payload.title,
              type: "success",
              duration: 0,
              message: payload.description
            })

            const notificationPayload = JSON.parse(payload.payload)

            const optionsCannotBeRemoved = notificationPayload.optionsCannotBeRemoved

            if (optionsCannotBeRemoved.length) {
                optionsCannotBeRemoved.forEach(async option => {
                    await this.displayUserNotification({
                        title: 'Warning',
                        type: "warning",
                        duration: 0,
                        message: `The ${option} option you are trying to remove is in use.`
                    })
                })
            }
        },
        async onCustomListsCreatedError(payload) {
            if (shownNotifications.has(payload.id)) return;
                shownNotifications.add(payload.id); 
            await this.displayUserNotification({
              title: payload.title,
              type: "warning",
              duration: 0,
              message: payload.description
            })
        },
        async onCustomListsUpdatesError(payload) {
            if (shownNotifications.has(payload.id)) return;
                shownNotifications.add(payload.id); 
            await this.displayUserNotification({
              title: payload.title,
              type: "warning",
              duration: 0,
              message: payload.description
            })
        },
        async onOverrideResourceUsage(payload) {
            if (shownNotifications.has(payload.id)) return;
                shownNotifications.add(payload.id); 
            await this.displayUserNotification({
              title: payload.title,
              type: "info",
              duration: 0,
              message: payload.description
            })
        },
        async onNoteUpdatesError(payload){
            if (shownNotifications.has(payload.id)) return;
                shownNotifications.add(payload.id); 
            const notificationPayload = JSON.parse(payload.payload)
            EventBus.$emit('update-note', notificationPayload.note)

            await this.displayUserNotification({
              title: payload.title,
              type: "warning",
              duration: 0,
              message: payload.description
            })
        },
        async onCounselingTableUpdates(payload){
            if (shownNotifications.has(payload.id)) return;
                shownNotifications.add(payload.id); 
            await this.displayUserNotification({
              title: payload.title,
              type: "success",
              duration: 0,
              message: payload.description
            })
        },

        async onCounselingTableUpdatesError(payload){
            if (shownNotifications.has(payload.id)) return;
                shownNotifications.add(payload.id); 
            await this.displayUserNotification({
              title: payload.title,
              type: "warning",
              duration: 0,
              message: payload.description
            })
        },

        async onTenantTableUpdates(payload) {
            if (shownNotifications.has(payload.id)) return;
                shownNotifications.add(payload.id); 
            await this.displayUserNotification({
              title: payload.title,
              type: "success",
              duration: 0,
              message: payload.description
            })
        },

        async onTenantTableUpdatesError(payload) {
            if (shownNotifications.has(payload.id)) return;
                shownNotifications.add(payload.id); 
            await this.displayUserNotification({
              title: payload.title,
              type: "warning",
              duration: 0,
              message: payload.description
            })
        },

        async onZipExportNotification(payload) {
            const { title, description, type } = payload || {}
            this.displayUserNotification({
                title,
                type,
                message: description,
            });
        },

        getProcessedZipDescription(notification) {
            return processExportNotificationDescription(notification, { legacyStopPropagation: true });
        },

        isExportNotification(notification) {
            return notification.notificationType === EXPORT_READY_FOR_DOWNLOAD
        },

        canClickExportNotification(notification) {
            // Non-export notifications are always clickable.
            // New-format export notifications (payload.s3Key present) are clickable so we
            // can regenerate a fresh presigned URL via rdsApi /downloadS3File on click.
            // Legacy export notifications without s3Key remain non-clickable in the bell;
            // their description HTML still renders the inline <a href="${redirectLink}"> link.
            if (!this.isExportNotification(notification)) return true
            try {
                const payload = JSON.parse(notification.payload)
                return Boolean(payload && payload.s3Key)
            } catch (e) {
                return false
            }
        },
    }  
}
</script>
<style scoped>
    .mt-0{
        margin-top: 0rem !important;
    }
    .pt-0{
        padding-top: 0rem !important;
    }
    .preline {
        white-space: pre-line;
    }
    .preline ::v-deep a {
        @apply text-brand font-semibold cursor-pointer underline transition-all duration-500;
    }
    .preline ::v-deep a:hover {
        @apply underline text-primary;
    }
</style>
